// Phase I (I-B, I2): shown instead of a module's pages when the tenant's plan leaves it out.
import { Lock } from 'lucide-react';
import { Link } from 'react-router';
import { PLAN_MODULES, type PlanModule } from '@denwen-msp/shared';
import { useAuth } from '@/app/auth';
import { EmptyState, buttonVariants } from '@/components/ui';

export function UpgradePrompt({ module }: { module: PlanModule }) {
  const { can } = useAuth();
  const name = PLAN_MODULES[module];
  return (
    <div className="p-6">
      <EmptyState
        icon={<Lock />}
        title={`${name} isn’t in your plan`}
        description={
          can('admin.admin')
            ? `Upgrade your subscription to use ${name}. The change is prorated, so you only pay for the rest of this period.`
            : `Ask your administrator to add ${name} to your company’s subscription.`
        }
        action={
          can('admin.admin') ? (
            <Link to="/admin/subscription" className={buttonVariants({ variant: 'primary' })}>
              See plans
            </Link>
          ) : undefined
        }
      />
    </div>
  );
}
